import Helmet from "react-helmet";
import React, { useEffect } from "react";
import { Spotipitan } from "./spotipitan";
import { Toaster } from "react-hot-toast";
import { NewFeaturesModal } from "../shared/new-features-modal";
import { ModalApi } from "../shared/login-form/view";
import { areNewFeaturesAvailable } from "../shared/new-features-modal/features";
import { auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";
import useUserStore, { DiscordUser } from "../../store/UserState";
import { Spotip17anFunctions } from "../../utils/api";
import { BrowserRouter as Router } from "react-router-dom";
import appLogo from "../../images/logo.png"


const AppView = () => {

    const newFeaturesModal = React.useRef<ModalApi>(null);
    const { loadUser, setDiscordUser, setSpotip17anUser } = useUserStore(state => state);

    useEffect(() => {
        window.onbeforeunload = function () {
            return "Are you sure you want to leave?";
        }

        if (areNewFeaturesAvailable()) {
            newFeaturesModal.current?.open();
        }

        const unsubscribe = onAuthStateChanged(auth, async () => {
            const currentUser = auth.currentUser;
            loadUser(currentUser ?? undefined);

            if (!currentUser || !currentUser.email) {
                setDiscordUser(null);
                setSpotip17anUser(null);
                return;
            }

            const joinSpotip17anUsers = Spotip17anFunctions.use('joinSpotip17anUsers');
            joinSpotip17anUsers.post({
                spotip17anUid: currentUser.uid,
                email: currentUser.email,
            }).catch(() => {
            });

            // Fetch Spotip17an Cap17an user details (artist role, id, etc.)
            Spotip17anFunctions.use('getSpotip17anData').call().then((data) => {
                if (data?.user) {
                    setSpotip17anUser(data.user);
                }
            }).catch((err) => {
                console.error("Error fetching spotip17an user data:", err);
            });

            // Fetch Discord profile from backend
            const getDiscordProfile = Spotip17anFunctions.use('getDiscordProfile');
            getDiscordProfile.post().then((res) => {
                if (res && res.discord_id) {
                    const discordUserObj: DiscordUser = {
                        id: res.discord_id,
                        username: res.discord_username || "",
                        global_name: res.discord_global_name || null,
                        avatar: res.discord_avatar || null,
                    };
                    setDiscordUser(discordUserObj);
                } else {
                    setDiscordUser(null);
                }
            }).catch((err) => {
                console.error("Error fetching Discord profile:", err);
            });
        });

        return () => unsubscribe();

    }, []);

    return (
        <Router>
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Spotip17an</title>

                    <link rel="icon" href={appLogo} />
                    <link rel="apple-touch-icon" href={appLogo} />
                </Helmet>
                <div className="toaster-container"><Toaster /></div>
                {/*<NewFeaturesModal ref={newFeaturesModal} />*/}
                <Spotipitan />
            </div>
        </Router>
    );
}

export default AppView;
